// Puoi leggere da variabili ambiente (.env) o usare un valore di default
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
// Costanti per localStorage
export const LS_ACCESS = "accessToken";
export const LS_REFRESH = "refreshToken";
export const LS_USER = "user";
export const LS_CURRENT_SEASON = "current_season";
// Endpoints
export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/api/login/`,
  LOGOUT: `${API_BASE_URL}/api/logout/`,
  TOKEN_REFRESH: `${API_BASE_URL}/api/token/refresh/`,
  SEND_RESET_PASSWORD: (id: number) => `${API_BASE_URL}/api/admin/send-reset/${id}/`,
  FORGOT_PASSWORD: `${API_BASE_URL}/api/forgot-password/`,
  RESET_PASSWORD: `${API_BASE_URL}/api/auth/reset-password/`,
  USERS: `${API_BASE_URL}/api/users/`,
  USER: (id: number) => `${API_BASE_URL}/api/users/${id}/`,
  LOGGED_USER: `${API_BASE_URL}/api/me/`,
  TOURNAMENTS: `${API_BASE_URL}/api/tournaments/`,
  TOURNAMENT: (id: number) => `${API_BASE_URL}/api/tournaments/${id}/`,
  TOURNAMENT_EVENTS: `${API_BASE_URL}/api/events/`,
  TOURNAMENT_EVENT: (id: number) => `${API_BASE_URL}/api/events/${id}/`,
  TOURNAMENT_EVENT_GENERATE_RESULTS: (id: number) => `${API_BASE_URL}/api/events/${id}/generate_results/`,
  EVENT_LOCATION: (id: number) => `${API_BASE_URL}/api/locations/${id}/`,
  EVENT_LOCATIONS: `${API_BASE_URL}/api/locations/`,
  TOURNAMENT_PARTICIPANTS: `${API_BASE_URL}/api/participants/`,
  TOURNAMENT_PARTICIPANT: (id: number) => `${API_BASE_URL}/api/participants/${id}/`,
  TOURNAMENT_PARTICIPANTS_BULK: `${API_BASE_URL}/api/participants/bulk/`,
  COMPETITION_STAGES: `${API_BASE_URL}/api/competition-stages/`,
  COMPETITION_STAGE: (id: number) => `${API_BASE_URL}/api/competition-stages/${id}/`,
  COMPETITION_STAGE_GENERATE: (id: number) => `${API_BASE_URL}/api/competition-stages/${id}/generate/`,
  COMPETITION_STAGE_GENERATE_KNOCKOUT: (id: number) => `${API_BASE_URL}/api/competition-stages/${id}/generate_knockout/`,
  COMPETITION_GROUPS: `${API_BASE_URL}/api/competition-groups/`,
  COMPETITION_GROUP: (id: number) => `${API_BASE_URL}/api/competition-groups/${id}/`,
  COMPETITION_GROUP_SET_PARTICIPANTS: (id: number) => `${API_BASE_URL}/api/competition-groups/${id}/set_participants/`,
  COMPETITION_MATCHES: `${API_BASE_URL}/api/matches/`,
  COMPETITION_MATCHES_EXPORT_PDF: `${API_BASE_URL}/api/matches/export-calendar-pdf/`,
  COMPETITION_MATCHES_EXPORT_EXCEL: `${API_BASE_URL}/api/matches/export-calendar-excel/`,
  COMPETITION_EVENT_MATCHES_EXPORT_PDF: `${API_BASE_URL}/api/matches/export-event-calendar-pdf/`,
  COMPETITION_EVENT_MATCHES_EXPORT_EXCEL: `${API_BASE_URL}/api/matches/export-event-calendar-excel/`,
  COMPETITION_MATCH: (id: number) => `${API_BASE_URL}/api/matches/${id}/`,
  COMPETITION_MATCH_SET_RESULT: (id: number) => `${API_BASE_URL}/api/matches/${id}/set_result/`,
  GROUP_STANDINGS: `${API_BASE_URL}/api/group-standings/`,
  SEASONS: `${API_BASE_URL}/api/seasons/`,
  SEASON_ENROLLMENTS: (seasonId: number) => `${API_BASE_URL}/api/seasons/${seasonId}/enrollments/`,
  DEFAULT_SEASON: `${API_BASE_URL}/api/seasons/default/`,
  SEASON: (id: number) => `${API_BASE_URL}/api/seasons/${id}/`,
  ALL_GENERAL_RANKING: `${API_BASE_URL}/api/general-ranking/top3/`,
  SEASON_GENERAL_RANKING: `${API_BASE_URL}/api/general-ranking/`,
};
export const PAGES_ENDPOINTS = {
  HOME: `/`,
  LOGIN: `/login`,
  USER_PROFILE: `/user-profile`,
  RESET_PASSWORD: `/reset-password`,
  FORGOT_PASSWORD: `/forgot-password`,
  TORNEI: `/tornei`,
  TORNEO_DETAIL: (id: string) => `/tornei/${id}`,
  CALENDARIO: `/calendario`,
  CLASSIFICA: `/classifica`,
  ADMIN: `/admin`,
  COOKIES_PRIVACY: `/cookies-privacy-policy`,
  CONDITIONS: `/terms-conditions`,
  ABOUT_US: `/about-us`,
};
